// @flow

import type {Merchant} from 'docs/data';
import type {AlternativeMerchantRequestModel} from 'docs/types';

export const transformAlternativeMerchant = (
  model: AlternativeMerchantRequestModel,
): Merchant => ({
  apiVersion: model.api_version,
  iconUrl: model.icon_url,
  nickname: model.nickname,
  token: model.token,
  isLoggedIn: false,
});
